import { useParams } from 'react-router-dom'

export const usePurchaseOrderIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
